import { useRef } from 'react';
import { HoverInfoTooltip } from '../../AuctionDetail/components/HoverInfo';
import { useCustomerHoverStateHandlers } from '../../AuctionDetail/hooks';

export const Seller = ({ vehicle }) => {
  const { isOpen, handleClose, handleOpen } = useCustomerHoverStateHandlers();
  const ref = useRef(null);

  if (!vehicle.user) {
    return 'N/A';
  }

  return (
    <HoverInfoTooltip
      anchorEl={ref.current}
      initialPage={`/admin/vehicles`}
      isPopoverOpened={isOpen}
      closeTooltip={handleClose}
      showTooltip={false}
      userId={vehicle.user.id}
      tooltipName={vehicle.user.dealership_name}
    >
      <span style={{ cursor: 'pointer' }} ref={ref} onClick={vehicle.user.is_bot ? undefined : handleOpen}>
        {vehicle.user.dealership_name}
      </span>
    </HoverInfoTooltip>
  );
};
